import { Badge } from 'root/src/client/v2/common/components/badge/Badge';
import Link from 'root/src/client/web/base/Link';
import { useIsCreator } from 'root/src/client/v2/auth/hooks/useIsCreator';
import { useDropBattlePassContext, } from 'root/src/client/v2/battlePass/features/DropBattlePass/contexts/dropBattlePass.context';
import analyticsSendItem from 'root/src/client/logic/analytics/util/analyticsSendItem';
import { BATTLE_PASS_ANALYTIC_EVENTS } from 'root/src/shared/battlePass/battlePass.analytics';
import { useUserId } from 'root/src/client/v2/common/hooks/useUser';
import { useDropEvent } from 'root/src/client/logic/dropEvent/hooks/useDropEvent';
export const BattlePassesBadges = () => {
    const { isCreator } = useIsCreator();
    const { battlePassMnemonicId, onBadgeChange, battlePassBadges } = useBattlePassesBadges();
    if (!isCreator) {
        return null;
    }
    return (<>
			<div className="flex flex-col sm:flex-row justify-start items-center my-4 gap-2">
				<p className="text-light-3 text-xl uppercase">Battle Passes:</p>
				<div className="flex flex-wrap justify-start items-center my-4 gap-2">
					{battlePassBadges.map((battlePass) => {
            const isActive = battlePass.mnemonicId === battlePassMnemonicId;
            return (<BattlePassBadge isActive={isActive} key={battlePass.mnemonicId} displayName={battlePass.displayName} onChange={onBadgeChange} mnemonicId={battlePass.mnemonicId}/>);
        })}
					<SeeMoreBadge />
				</div>
			</div>
		</>);
};
const useBattlePassesBadges = () => {
    var _a;
    const dropEvent = useDropEvent();
    const { battlePassMnemonicId, setBattlePassMnemonicId } = useDropBattlePassContext();
    const onBadgeChange = (mnemonicId) => {
        if (mnemonicId) {
            analyticsSendItem(BATTLE_PASS_ANALYTIC_EVENTS.BADGE_CLICK, mnemonicId);
        }
        setBattlePassMnemonicId(mnemonicId);
    };
    return {
        battlePassBadges: (_a = dropEvent === null || dropEvent === void 0 ? void 0 : dropEvent.battlePassBadges) !== null && _a !== void 0 ? _a : [],
        onBadgeChange,
        battlePassMnemonicId,
    };
};
export const BattlePassBadge = ({ isActive, displayName, onChange, mnemonicId }) => {
    const handlerOnChange = () => {
        if (!isActive) {
            onChange(mnemonicId);
            return;
        }
        onChange(null);
    };
    return (<Badge onClick={handlerOnChange} data-active={isActive} className="select-none cursor-pointer capitalize data-[active=true]:motion-safe:animate-slide-up hover:brightness-100 motion-safe:duration-150 bg-primary brightness-50 data-[active=true]:brightness-100">
			{displayName}
		</Badge>);
};
export const SeeMoreBadge = () => {
    const userId = useUserId();
    return (<Link onClick={() => {
            analyticsSendItem(BATTLE_PASS_ANALYTIC_EVENTS.SEE_MORE, userId);
        }} href="/battle-passes">
			<div className="select-none text-sm text-center sm:py-[2px] sm:px-[10px] px-[14px] py-[6px] rounded text-white font-bold cursor-pointer border-2 border-primary hover:brightness-100  brightness-50 bg-transparent">
				See more battle passes...
			</div>
		</Link>);
};
